import React from 'react';

const ModalError = params => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={params.width || 32}
    height={params.height || 32}
    viewBox="0 0 32 32"
  >
    <g fill="none" fillRule="evenodd">
      <g fill={params.color || '#FB8B01'}>
        <g>
          <g>
            <g>
              <path
                d="M14.77 5.997c.117-.182.275-.335.462-.449.679-.413 1.573-.212 1.998.449l11.883 18.51c.144.224.22.484.22.748 0 .78-.649 1.412-1.45 1.412H4.117c-.272 0-.538-.075-.769-.215-.679-.413-.885-1.284-.46-1.945L14.77 5.997zM16 21.333c-.736 0-1.333.597-1.333 1.334 0 .736.597 1.333 1.333 1.333s1.333-.597 1.333-1.333c0-.737-.597-1.334-1.333-1.334zM16 12c-.736 0-1.333.597-1.333 1.333v5.334c0 .736.597 1.333 1.333 1.333s1.333-.597 1.333-1.333v-5.334c0-.736-.597-1.333-1.333-1.333z"
                transform="translate(-3898 -4046) translate(3559 3966) translate(24 80) translate(315)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default ModalError;
